import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// icons
import { PlusOutlined } from '@ant-design/icons';

function AddButton({
  uniqueKey,
  onClick,
  // default props
  className
}) {
  const childClassNames = classNames('extra-bar-item', 'add-new-extra', className);
  
  return (
    <div
      key={`add-new-${uniqueKey}`}
      className={childClassNames}
      onClick={onClick}
    >
      <PlusOutlined />
    </div>
  );
};

AddButton.defaultProps = {
  uniqueKey: 'simple'
};
AddButton.propTypes = {
  uniqueKey: PropTypes.string,
  onClick: PropTypes.func,
};

export default memo(AddButton);